import React, { FormEvent, FunctionComponent } from 'react';
import { ForgeIcon, ForgeInlineMessage, ForgeRadio } from '@tylertech/forge-react';
import { fetchTranslation } from 'common/locale';

const t = (k: string) => fetchTranslation(k, 'shared.explore_grid.export_dataset_modal');

export enum PossibleVersions {
  Soda2 = 'soda2',
  Soda3 = 'soda3',
}
interface Props {
  selectedVersion: PossibleVersions;
  handleRadioVersionChange: (selectedVersion: PossibleVersions) => void;
}

const VersionRadioButtons: FunctionComponent<Props> = ({ selectedVersion, handleRadioVersionChange }) => {
  const soda3Warning = selectedVersion === 'soda3' && (
    <ForgeInlineMessage theme="info" className="soda3-auth-needed">
      <ForgeIcon name="info_outline" slot="icon" />
      <div dangerouslySetInnerHTML={{ __html: t('soda3_authentication_needed') }} />
    </ForgeInlineMessage>
  );

  return (
    <>
      <div className="version-radio-group" data-testid="radio-group-version" role="radiogroup">
        <span className="label">{t('version')}</span>
        <ForgeRadio
          className="version-radio-buttons"
          name="radio-versions"
          data-testid="radio-soda3"
          value={PossibleVersions.Soda3}
          onClick={() => handleRadioVersionChange(PossibleVersions.Soda3)}
          checked={selectedVersion === 'soda3'}
        >
          <span>{t('soda3')}</span>
        </ForgeRadio>
        <ForgeRadio
          className="version-radio-buttons"
          name="radio-versions"
          data-testid="radio-soda2"
          value={PossibleVersions.Soda2}
          onClick={() => handleRadioVersionChange(PossibleVersions.Soda2)}
          checked={selectedVersion === 'soda2'}
        >
          <span>{t('soda2')}</span>
        </ForgeRadio>
      </div>
      {soda3Warning}
    </>
  );
};

export default VersionRadioButtons;
